import { analytics } from '../analytics';

const html5VideoSelector = '.video-container video.mhe-video-comp';

export function registerHtml5VideoAnalytics(): void {
  analytics(html5VideoSelector)
    .name('html5-video-play')
    .on('play')
    .collectCommon()
    .enrich(({ element }) => ({
      'video-start-from-time': (element as HTMLVideoElement).currentTime,
    }))
    .emit('video-play');

  analytics(html5VideoSelector)
    .name('html5-video-pause')
    .on('pause')
    .collectCommon()
    .enrich(({ element }) => {
      const video = element as HTMLVideoElement;
      return {
        'video-pause-at-time': video.currentTime,
        'video-complete-percentage': Math.floor((video.currentTime / video.duration) * 100),
      };
    })
    .emit('video-pause');

  analytics(html5VideoSelector)
    .name('html5-video-ended')
    .on('ended')
    .collectCommon()
    .set('video-complete-percentage', 100)
    .emit('video-ended');
}
